function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Grupo 803"
}, React.createElement("g", {
  "data-name": "Grupo 791"
}, React.createElement("path", {
  "data-name": "Trazado 82",
  d: "M16.626 8.062l-3.64 3.64a.792.792 0 01-1.121 0l-3.632-3.64a.772.772 0 010-1.1.782.782 0 011.1 0l2.32 2.32v-6.5a.781.781 0 011.561 0v6.5l2.32-2.32a.778.778 0 011.1 1.1z",
  fill: "#116099"
})), React.createElement("g", {
  "data-name": "Grupo 792"
}, React.createElement("path", {
  "data-name": "Trazado 82",
  d: "M.227 3.873l3.64-3.64a.792.792 0 011.121 0l3.632 3.64a.772.772 0 010 1.1.782.782 0 01-1.1 0L5.2 2.653v6.5a.781.781 0 01-1.561 0v-6.5l-2.32 2.32a.778.778 0 01-1.1-1.1z",
  fill: "#116099"
})));

var SvgBespokenRearrangeIcon = function SvgBespokenRearrangeIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16.852 11.935"
  }, props), _ref);
};

export default SvgBespokenRearrangeIcon;